import { createContext, useContext, type ReactNode } from 'react';
import { createPortal } from 'react-dom';

/**
 * ② 좌측 상세의 "하위 메뉴 아래" 자리 (2026-08-20).
 *
 * 시안(`예약 화면 재설계`)은 자원 목록·필터를 컨텐츠(③) 왼쪽이 아니라 ② 좌측 상세 안에 둔다
 * (목록 폭 520 → 240px). 그런데 ② 는 부모 셸(`ReservationPage`)이 소유하고 목록 내용은
 * 자식 라우트가 안다 — 그래서 부모가 빈 칸을 하나 내주고 자식이 **포털**로 채운다.
 *
 * state 로 ReactNode 를 올리지 않는 이유: 매 렌더마다 새 노드가 되어 부모-자식 갱신 루프가 난다.
 * DOM 노드 하나만 컨텍스트로 넘기면 자식 트리(컨텍스트·이벤트 버블링)는 그대로 유지된다.
 */
export const ReservationAsideContext = createContext<HTMLElement | null>(null);

export function ReservationAside({ children }: { children: ReactNode }) {
  const host = useContext(ReservationAsideContext);
  // 부모 셸 없이(테스트에서 단독 렌더) 쓰이면 조용히 아무것도 안 그린다 — 화면은 ③ 만으로 성립한다.
  if (!host) return null;
  return createPortal(children, host);
}
